import { Amplify } from 'aws-amplify'
import axios from 'axios'
import { sendDatadogError } from '../EngagementPlatform/services/datadog'
import { getRegionFromUrl } from '../../utils'

export const CONNECTIVITY = 'CONNECTIVITY'

// ACTION CREATORS
/** **************** CONNECTIVITY ***************** */
export function connected(status) {
  return (dispatch) => {
    dispatch({
      type: CONNECTIVITY,
      data: status ? 'connected' : 'disconnected'
    })
  }
}

export function getAmplifyClientMetadata() {
  return {
    tenant_name: axios.tenant,
    environment: process.env.REACT_APP_ENV
  }
}

function cognitoConfig(authConfig, hasRedirectUrl) {
  return {
    Auth: {
      Cognito: {
        userPoolId: authConfig.user_pool_id,
        userPoolClientId: authConfig.user_pool_client_id,
        loginWith: {
          oauth: {
            domain: authConfig.domain,
            redirectSignIn: [computeRedirect(authConfig.redirect_subdomain)],
            redirectSignOut: [computeRedirect(authConfig.redirect_subdomain, hasRedirectUrl)],
            responseType: 'code',
            scopes: []
          }
        }
      }
    }
  }
}

const OAUTH_VALID_DOMAINS = [
  '.elevatesecurity.com',
  '.elevatesecurity-staging.com',
  '.localtest.me'
]

function computeRedirect(redirectSubdomain, hasRedirectUrl = false) {
  let securePort = ''
  if (window.location.port && window.location.port !== 80 && window.location.port !== 443) {
    securePort =
      window.location.protocol === 'https:'
        ? `:${window.location.port}`
        : `:${Number(window.location.port) + 1}`
  }
  const validDomain = OAUTH_VALID_DOMAINS.find((d) => window.location.hostname.endsWith(d))
  if (!validDomain) {
    throw new Error(
      `Could not computeRedirect, no valid domain found for ${window.location.hostname}`
    )
  }

  if (redirectSubdomain === 'oauth') {
    // eslint-disable-next-line no-param-reassign
    redirectSubdomain = window.location.hostname?.split(/[._-]/)?.[0] || redirectSubdomain
  }
  const host = `${redirectSubdomain}${getRegionFromUrl(window.location.host, '.')}${validDomain}`
  const secureOrigin = `https://${host}${securePort}`
  let redirectUrl = `${secureOrigin}/engagement`

  // patch window.history to prepare it to receive a URL from a different hostname
  /*
   * This hack is necessary because amplify Auth tries to do a replaceState with the redirectSignIn url into the window.history after a successful login
   * and this only works if the hostname is the same. We don't really care about the redirectSignIn after a successful login anyway.
   */
  const _replaceState = window.history.replaceState.bind(window.history)
  const params = new URLSearchParams(window.location.search)
  window.history.replaceState = (data, title, url = null) => {
    if (url === redirectUrl) {
      if (params.get('mode') === null) {
        // This condition is for slack integration. It redirect with Mode Param.
        // the redirectUrl is for a different hostname so we can't use it
        _replaceState(data, title, `/${window.location.pathname}`.replace('//', '/')) // just strip the query string which contains the OAuth ?code
      }
    } else {
      _replaceState(data, title, url)
    }
  }

  if (hasRedirectUrl) {
    redirectUrl = `${redirectUrl}?admin`
  }

  return redirectUrl
}

export async function configureAmplify(authConfig) {
  try {
    const hasRedirectUrl = window.location.href.includes('?admin')
    Amplify.configure(cognitoConfig(authConfig, hasRedirectUrl))
  } catch (err) {
    sendDatadogError('configureAmplify error', 'error', err)
  }
}
